/**
 * useClockInOut — React Query mutations be- és kijelentkezéshez
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clockIn, clockOut, type AttendanceRecord, type ClockInInput } from '../api/hr-api';
import { attendanceQueryKey } from './useAttendance';

export function useClockIn() {
  const queryClient = useQueryClient();

  return useMutation<AttendanceRecord, Error, ClockInInput | undefined>({
    mutationFn: async (data?: ClockInInput) => {
      const res = await clockIn(data);
      return res.data;
    },
    onSuccess: () => {
      const now = new Date();
      void queryClient.invalidateQueries({
        queryKey: attendanceQueryKey(now.getFullYear(), now.getMonth() + 1),
      });
    },
  });
}

export function useClockOut() {
  const queryClient = useQueryClient();

  return useMutation<AttendanceRecord, Error, void>({
    mutationFn: async () => {
      const res = await clockOut();
      return res.data;
    },
    onSuccess: () => {
      const now = new Date();
      void queryClient.invalidateQueries({
        queryKey: attendanceQueryKey(now.getFullYear(), now.getMonth() + 1),
      });
    },
  });
}
